import { Component, OnInit, Input } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';

@Component({
  selector: 'app-claimed-bar',
  templateUrl: './claimed-bar.component.html',
  styleUrls: ['./claimed-bar.component.scss'],
})
export class ClaimedBarComponent implements OnInit {

  @Input() claimed: any
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration
  ) { }

  ngOnInit() { 
  }


}
